// pages/ReclamarCoins.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../Firebase/Firebase';
import { onAuthStateChanged } from 'firebase/auth';

const ReclamarCoins = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Marca que vino desde QR
    localStorage.setItem('isClaiming', 'true');

    onAuthStateChanged(auth, (user) => {
      if (user) {
        // Ya está logueado, ir directo a proceso de reclamo
        navigate('/procesar-reclamo');
      } else {
        // No está logueado, redirigir al login
        navigate('/login');
      }
    });
  }, []);

  return <p>Procesando tu QR...</p>;
};

export default ReclamarCoins;
